import React from 'react';
import { enhancedExportAllFiles } from '../../utils/scriptExporters';
import { exportScriptFiles } from '../../utils/scriptExporters';

export const EnhancedFileExporter = ({ 
  npcNames, 
  dialogues, 
  buttons, 
  commands, 
  entityIds, 
  config 
}) => {
  const handleExport = () => {
  if (!npcNames || npcNames.length === 0) {
    alert("No NPCs to export. Please add NPCs first.");
    return;
  }
  
  console.log('=== EXPORT STARTED ===');
  console.log('Config:', config);
  console.log('Scene tracking:', config.sceneTracking);
  
  // Choose export method based on configuration
  if (config.sceneTracking === 'scripts') {
    console.log('Using script-based export');
    try {
      exportScriptFiles(npcNames, dialogues, buttons, commands, entityIds, config);
      console.log('Export function called successfully');
    } catch (error) {
      console.error('ERROR IN EXPORT:', error);
      alert('Export error: ' + error.message);
    }
  } else {
    console.log('Using traditional export');
    // Use enhanced traditional export (scores/not_sure)
    enhancedExportAllFiles(npcNames, dialogues, buttons, commands, entityIds, config);
  }
};

  const getExportButtonText = () => {
    if (config.sceneTracking === 'scripts') {
      return 'Export Scripts & Dialogues';
    }
    return 'Export Dialogues';
  };

  return (
    <div className="exporter-container">
      <button 
        className="button-19 export-button"
        onClick={handleExport}
      >
        {getExportButtonText()}
      </button>
      
      <div style={{
        fontSize: '0.7rem',
        color: 'rgba(255, 255, 255, 0.6)',
        textAlign: 'center',
        marginTop: '5px',
        lineHeight: '1.2'
      }}>
      </div>
      
      {/* Configuration reminder */}
      <div style={{
        fontSize: '0.6rem',
        color: 'rgba(255, 255, 255, 0.4)',
        textAlign: 'center',
        marginTop: '3px',
        fontStyle: 'italic'
      }}>
      </div>
    </div>
  );
};

export default EnhancedFileExporter;